<template>
  <Layout>
    <div
      class="asset-created-message"
    >
      <Loader
        v-if="isLoading"
        is-loading
      />
      <div v-else>
        <div>Activation successful!</div>
        <br>
        {{ assetName }} is now being tracked.<br>
        <br><br>
        <v-btn
          dark
          @click="goHome"
        >
          Return to home
        </v-btn>
      </div>
    </div>
  </Layout>
</template>
<script>
import { routeNames } from '../../constants';
import Layout from '../../components/organisms/layout/nb-iot-layout';
import Loader from '../../components/atoms/loader/loader';
import rules from '../../mixins/input-validation-rules';

export default {
  name: 'NbIotAssetCreated',
  components: {
    Layout,
    Loader,
  },
  mixins: [rules],
  props: {
    assetId: { type: String, required: true },
    assetName: { type: String, required: true },
    validRoute: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    assetErrorMessage() {
      return this.$store.state.assets.errorMessage;
    },
  },
  created() {
    if (!this.validRoute || !this.assetId || !this.assetName) {
      this.goHome();
    } else {
      this.getAssetData();
    }
  },
  methods: {
    async goHome() {
      this.$router.replace({ name: routeNames.home });
    },
    async goToAssetDetail() {
      this.$router.replace({
        name: routeNames.nbIot.detail,
        query: { assetId: this.assetId },
      });
    },
    async getAssetData() {
      const assetData = await this.$store.dispatch('assets/getAsset', { id: this.assetId, skipRedirect: true });

      if (!assetData) {
        // error fetching asset data
        // if error message is permission error, then stay on this page
        if (!this.assetErrorMessage
          || (!this.assetErrorMessage.includes('User does not have necessary permission')
            && !this.assetErrorMessage.includes('Request failed with status code 401'))) {
          this.goHome();
        }
      } else {
        this.goToAssetDetail();
      }

      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.asset-created-message {
  padding: 50px;
  display: flex;
  flex-direction: column;
  text-align: center;
  line-height: 28px;
}
</style>
